const stats = [
  {
    value: '3.4M+',
    label: 'Australian homes with solar',
    sub: 'World-leading per capita adoption',
    icon: 'ri-home-smile-line',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    value: '39%',
    label: 'Electricity from renewables',
    sub: 'And growing year on year',
    icon: 'ri-leaf-line',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    value: '$2,950',
    label: 'Max rebate available',
    sub: 'Varies by state and system type',
    icon: 'ri-government-line',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    value: '3–6 yrs',
    label: 'Typical payback period',
    sub: 'Commercial systems often faster',
    icon: 'ri-time-line',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
];

export default function SolarStats() {
  return (
    <section className="bg-foreground-950 py-14 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className={`w-12 h-12 rounded-xl ${stat.bg} flex items-center justify-center mx-auto mb-4`}>
                <i className={`${stat.icon} text-xl ${stat.color}`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-extrabold text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm font-semibold text-white/80 mb-1">{stat.label}</div>
              <div className="text-xs text-white/40">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}